import { AfterViewInit, Directive, ElementRef, Input, OnChanges, Renderer2, SimpleChanges } from '@angular/core';

@Directive({
    selector: '[resizableColumn]',
    standalone: false
})
export class ResizableColumnDirective implements AfterViewInit, OnChanges {
  @Input('resizableColumn') columnName!: string;
  static widths: Record<string, number> = {};

  constructor(public el: ElementRef<HTMLElement>, private renderer: Renderer2) {}

  ngAfterViewInit(): void {
    this.applyStoredWidth();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.columnName && !changes.columnName.isFirstChange()) {
      this.applyStoredWidth();
    }
  }

  private applyStoredWidth(): void {
    const stored = ResizableColumnDirective.widths[this.columnName];
    const current = this.el.nativeElement;
    if (stored) {
      this.renderer.setStyle(current, 'flex', `0 0 ${stored}px`);
    } else {
      this.renderer.removeStyle(current, 'flex');
    }
  }
}
